import { Card, Col, Row, Tabs } from 'antd';
import styled from 'styled-components';
import { HSCard, HS_CARD_ALERT_VARIANTS } from '@/Components/Common/HSWidget';
import { OfflineIcon } from '../Common/Icons';

export const UserHubsViewTabs = styled(Tabs)`
  width: fit-content;

  .ant-tabs-nav {
    margin: 0;
    padding: 4px;
    border: 1px solid #f5f5f5;
    border-radius: 8px;
    background: #ffffff;
  }

  .ant-tabs-nav-wrap,
  .ant-tabs-nav-list {
    gap: 4px;
  }

  .ant-tabs-tab {
    margin: 0;
    padding: 8px 16px;
    min-height: 32px;
    border-radius: 4px;
    background: #f5f5f5;
    color: #11314a;
    transition: background-color 0.2s ease;
  }

  .ant-tabs-tab[data-node-key='list'] {
    width: 48px;
  }

  .ant-tabs-tab[data-node-key='tile'] {
    width: 54.5px;
    margin: 0;
  }

  .ant-tabs-tab:hover {
    color: #11314a;
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    background: #d9ecfa;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #11314a;
  }

  .ant-tabs-ink-bar,
  .ant-tabs-content-holder {
    display: none;
  }

  .ant-tabs-tab-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  .user-hubs-view-tab-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .user-hubs-view-tab-list {
    width: 16px;
    height: 16px;
  }

  .user-hubs-view-tab-tile {
    width: 22.5px;
    height: 19px;
  }

  .anticon {
    font-size: 16px;
  }
`;

export const TileViewRow = styled(Row).attrs(() => ({ gutter: [10, 10] }))`
  align-items: stretch;
`;

export const TileViewCol = styled(Col).attrs(() => ({
  xs: 24,
  sm: 12,
  md: 8,
  lg: { flex: '20%' },
}))`
  display: flex;
`;

export const TileCard = styled(HSCard).attrs(() => ({
  component: Card,
  height: '100%',
  alertVariant: HS_CARD_ALERT_VARIANTS.OVERLAY,
}))`
  width: 100%;
  cursor: pointer;
  overflow: hidden;

  .ant-card-body {
    height: 100%;
    padding: 24px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
  }
`;

export const TileMainContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const TileProfileWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TileProfileImage = styled.img`
  width: 59px;
  height: 59px;
  border-radius: 59px;
  object-fit: cover;
  border: 2px solid ${(props) => (props.$isIncomplete ? '#f9c030' : '#005d98')};
`;

export const TileProfileIncompleteText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 6px;
  gap: 8px;
  background: #f9c030;
  border-radius: 99px;
  position: absolute;
  height: 19px;
  width: 78px;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);

  .incomplete-text {
    width: 66px;
    height: 15px;
    font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #0a0a0a;
  }
`;

export const OnlineIcon = styled.span`
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  border: 2px solid #ffffff;
  background: #4bd37b;
`;

export const CustomOfflineIcon = styled(OfflineIcon)`
  position: absolute;
  right: ${(props) => (props.$isIncomplete ? '-12px' : '-2px')};
  bottom: ${(props) => (props.$isIncomplete ? '-9px' : '-2px')};
  width: 20px;
  height: 20px;
  border-radius: 999px;
  border: 2px solid #ffffff;
  background: #bfbfbf;
`;

export const TileName = styled.div`
  width: 100%;
  text-align: center;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #113e57;
`;

export const TileInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const TileInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TileInfoValue = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  text-align: center;
  color: #525252;
`;

export const TileRelation = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  text-align: center;
  color: #113e57;
`;

export const TileInfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
    fill: #003252;
  }
`;

export const TileAlertRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  min-height: 24px;
`;

export const TileAlertIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
  }

  path {
    fill: #9747ff;
  }
`;

export const ShowMoreButton = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 4px 12px;
  border-radius: 999px;
  cursor: pointer;
  align-self: center;

  .show-more-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 0 8px;
    white-space: nowrap;
    color: #4e758e;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .show-more-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    color: #4e758e;
  }
`;

export const ActionButtonsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

export const AddAccountButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px;
  width: 98px;
  height: 48px;
  background: #d9ecfa;
  border-radius: 999px;
  cursor: pointer;
  width: auto;
  white-space: nowrap;

  .user-hubs-add-account-block {
    display: flex;
    flex-direction: row;

    .user-hubs-add-account-icon {
      width: 24px;
      height: 24px;
      fill: #003252;
      stroke: #003252;
      max-height: 32px;
    }

    svg > circle {
      display: none !important;
    }

    .user-hubs-add-account-label-block {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0px 8px;
      gap: 10px;

      .user-hubs-add-account-label {
        font-family: 'Euclid Circular A';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        color: #003252;
      }
    }
  }
`;
